import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { Preferences } from "@capacitor/preferences";
import { ITenant } from "../services/tenant/tenantService";

const STORAGE_NAME = "tenant-detail-storage";

interface TenantDetailState {
  tenant: ITenant | null;
  isLoading: boolean;
  isInitialLoaded: boolean;
  setTenant: (tenant: ITenant) => void;
  setIsLoading: (isLoading: boolean) => void;
  setIsInitalLoaded: (isInitialLoaded: boolean) => void;
  reset: () => void;
}

const capacitorPreferencesStorage = {
  getItem: async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  setItem: (key: string, value: string) => {
    return Preferences.set({ key, value });
  },
  removeItem: (key: string) => {
    return Preferences.remove({ key });
  },
};

const useTenantDetailStore = create<TenantDetailState>()(
  devtools(
    persist(
      (set) => ({
        tenant: null,
        isLoading: true,
        isInitialLoaded: false,
        setTenant: (tenant: ITenant) => {
          set({
            tenant: tenant,
          });
        },
        setIsLoading: (isLoading: boolean) => set({ isLoading }),
        setIsInitalLoaded: (isInitialLoaded: boolean) =>
          set({ isInitialLoaded }),
        reset: () => {
          set({
            tenant: null,
            isLoading: true,
            isInitialLoaded: false,
          });
        },
      }),
      {
        name: STORAGE_NAME,
        storage: createJSONStorage(() => capacitorPreferencesStorage),
      }
    )
  )
);

export default useTenantDetailStore;
